module.exports = __webpack_public_path__ + "static/Wynajem-Ksero-Bizhubc654-414c1e5ff3a8df5959ebb9f6c080a485.png";